export const generateGruserObjectId = ({ gruserId, gruserTypeid, gruserItemid })=>{
    return `${gruserId}-${gruserTypeid}-${gruserItemid || 'null'}`;
};
